import React from 'react'
// import TextInput from 'glic-ui-components/dist/js/TextInput';
// import FormControl from 'glic-ui-components/dist/js/FormControl';
import {FormControl,Checkbox} from 'glic-ui-components';
const CheckBoxField = ({  onChangeCheck, id, required, checked}) => {
    // console.log("pass",id)
    return (
        <div className="row">
            <div className='col-12'>
                {id === 'Phone' &&
                <>
                    {required === true  ? 
                  
                    <FormControl
                        isDisabled={false}
                        validations={{
                            required: { message: 'Field is required.' },
                        }}
                        validateOnChange
                        validateOnBlur
                        // onValidate={((result) => console.log('Text input validation result: ', result))}
                    >
                        
                        <Checkbox
                            id={id}
                            name={id}
                            label={id}
                            isChecked={checked}
                            // onChange={(e, checkboxArray, checkboxItemsArray) => console.log(e, checkboxArray, checkboxItemsArray)}
                            onChange={(e, items) => onChangeCheck(e, items,)}
                        // onSubmit={handlesubmit}

                        />
                    </FormControl>
                    :
                   
                    <Checkbox
                    id={id}
                    name={id}
                    label={id}
                    isChecked={checked}
                    // onChange={(e, checkboxArray, checkboxItemsArray) => console.log(e, checkboxArray, checkboxItemsArray)}
                    onChange={(e, items) => onChangeCheck(e, items)}
                // onSubmit={handlesubmit}

                />
                }
                </>
                
                }
                {id === 'Email' &&
                <>
                 {required === true && id === 'Phone'? 
                  
                    <FormControl
                        isDisabled={false}
                        validations={{
                            required: { message:'Any one Field is required.'},
                        }}
                        validateOnChange
                        validateOnBlur
                        onValidate={((result) => console.log('Text input validation result: ', result))}
                    >
                        
                        <Checkbox
                            id={id}
                            name={id}
                            label={id}
                            isChecked={checked}
                            // onChange={(e, checkboxArray, checkboxItemsArray) => console.log(e, checkboxArray, checkboxItemsArray)}
                            onChange={(e, items) => onChangeCheck(e, items,)}
                        // onSubmit={handlesubmit}

                        />
                    </FormControl>
                    :
                   
                    <Checkbox
                    id={id}
                    name={id}
                    label={id}
                    isChecked={checked}
                    // onChange={(e, checkboxArray, checkboxItemsArray) => console.log(e, checkboxArray, checkboxItemsArray)}
                    onChange={(e, items) => onChangeCheck(e, items)}
                // onSubmit={handlesubmit}

                />
                }
                </>
                
                }

               
            </div>
        </div>
    )
}

export default CheckBoxField
